module.exports = __webpack_public_path__ + "img/dy_top_bg.9065c77e.png";